module.exports = __webpack_public_path__ + "img/Bitmap.ff4eddaf.png";